module.exports = __webpack_public_path__ + "static/media/hiw-icon-true-offer-se.43151f77.png";